var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"advanced-search"},[(!_vm.type)?_c('h1',{staticClass:"advanced-search__title"},[_vm._v("Advanced Search"),_c('span',[_vm._v("powered by Google")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"has-margin-t30",attrs:{"id":"search-results"},domProps:{"innerHTML":_vm._s(_vm.googleCustomSearchResults)}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88263e4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/AdvancedSearch.vue
// module id = KsO0
// module chunks = 0